// assets/js/layout/menu.js

/**
 * Configurazione centralizzata del menu della sidebar.
 * Ogni voce può avere una proprietà 'roles' che è un array di idRuolo.
 * Se 'roles' non è presente, la voce è visibile a tutti gli utenti autenticati.
 */
export const menuConfig = [
    {
        icon: 'ki-home-3',
        title: 'Home',
        path: '/',
        roles: [1, 2, 3] // Visibile a tutti i ruoli
    },
    {
        icon: 'ki-drop',
        title: 'Serv. Idrico',
        roles: [1, 2, 3],
        children: [
            {
                title: 'Letture',
                path: '/user/letture',
            },
            {
                title: 'Fatture',
                path: '/user/fatture',
            },
            {
                title: 'Estratto conto',
                path: '/user/estratto',
            }
        ]
    },
    {
        icon: 'ki-information-1',
        title: 'Avvisi',
        path: '/residenti/avvisi',
        roles: [1, 2, 3] // Visibile a tutti i ruoli
    },
    {
        icon: 'ki-notification-bing',
        title: 'Segnalazioni',
        path: '/residenti/tickets',
        roles: [1, 2, 3] // Visibile a tutti i ruoli
    },
    {
        type: 'separator',
        roles: [1, 2]
    },
    {
        type: 'heading',
        title: 'Gestione',
        roles: [1, 2]
    },
    {
        icon: 'ki-users',
        title: 'Residenti',
        roles: [1, 2], // Visibile solo a Super Admin e Admin
        children: [
            {
                title: 'Anagrafiche',
                children: [
                    { title: 'Lista', path: '/residenti/anagrafiche/lista' },
                    { title: 'Nuova anagrafica', path: '/residenti/nuovo' }
                ]
            }
        ]
    },
    {
        icon: 'ki-drop',
        title: 'Serv. Idrico',
        roles: [1, 2],
        children: [
            {
                title: 'Tariffazione',
                children: [
                    { title: 'Gestione tariffe', path: '/servizi/idrico/tariffe' },
                    { title: 'Gestione oneri', path: '/servizi/idrico/oneri' },
                    { title: 'Gestione extra', path: '/servizi/idrico/extra' }
                ]
            },
            {
                title: 'Letture',
                children: [
                    { title: 'Lista letture', path: '/servizi/idrico/letture' },
                    { title: 'Nuova lettura', path: '/servizi/idrico/lettura' }
                ]
            },
            {
                title: 'Fatturazione',
                children: [
                    { title: 'Da emettere', path: '/servizi/idrico/fatturazione/emettere' },
                    { title: 'Emesse', path: '/servizi/idrico/fatturazione/emesse' },
                    { title: 'Solleciti', path: '/servizi/idrico/fatturazione/solleciti' }
                ]
            },
            {
                title: 'Situazione contabile',
                path: '/servizi/idrico/contabilita',
                isDirectLink: true // Flag per indicare che non è un sottomenu
            },
            {
                title: 'Perdite idriche',
                path: '/servizi/idrico/perdite',
                isDirectLink: true // Flag per indicare che non è un sottomenu
            },
            {
                title: 'Statistiche',
                path: '/servizi/idrico/consumi/statistiche',
                isDirectLink: true // Flag per indicare che non è un sottomenu
            },
            {
                title: 'Stampe',
                children: [
                    { title: 'Letture', path: '/servizi/idrico/stampe/letture' },
                    { title: 'Geologo', path: '/servizi/idrico/stampe/geologo' },
                    { title: 'Contabili', path: '/servizi/idrico/stampe/contabili' },
                ]
            }
        ]
    },
    {
        icon: 'ki-notification-bing',
        title: 'Segnalazioni',
        path: '/tickets/lista',
        roles: [1, 2] // Visibile a tutti i ruoli
    },
    {
        icon: 'ki-information-1',
        title: 'Gest. avvisi',
        path: '/residenti/avvisi',
        roles: [1, 2]
    },
    {
        icon: 'ki-setting',
        title: 'Impostazioni',
        path: '/impostazioni',
        roles: [1, 2] // Visibile solo a Super Admin e Admin
    }
];